export const room_facilities = {
  1: {
    label: "Bollitore tè macchina caffè",
    icon: ""
  },
  2: {
    label: "Connessione internet",
    icon: ""
  },
  3: {
    label: "Minibar",
    icon: ""
  },
  4: {
    label: "Doccia",
    icon: ""
  },
  5: {
    label: "Vasca",
    icon: ""
  },
  6: {
    label: "Cassaforte",
    icon: ""
  },
  7: {
    label: "Canali pay per view",
    icon: ""
  },
  8: {
    label: "TV",
    icon: ""
  },
  9: {
    label: "Telefono",
    icon: ""
  },
  10: {
    label: "Fax",
    icon: ""
  },
  11: {
    label: "Aria condizionata",
    icon: ""
  },
  12: {
    label: "Asciugacapelli",
    icon: ""
  },
  13: {
    label: "Sveglia sveglia telefonica",
    icon: ""
  },
  14: {
    label: "Vasca idromassaggio",
    icon: ""
  },
  15: {
    label: "Ferro da stiro",
    icon: ""
  },
  16: {
    label: "Angolo cottura",
    icon: ""
  },
  17: {
    label: "Balcone",
    icon: ""
  },
  18: {
    label: "Stirapantaloni",
    icon: ""
  },
  19: {
    label: "Accappatoio",
    icon: ""
  },
  20: {
    label: "Vasca da bagno con idromassaggio",
    icon: ""
  },
  21: {
    label: "Radio",
    icon: ""
  },
  22: {
    label: "Frigorifero",
    icon: ""
  },
  23: {
    label: "Scrivania",
    icon: ""
  },
  24: {
    label: "Bagno in comune",
    icon: ""
  },
  25: {
    label: "Ferro e asse da stiro",
    icon: ""
  },
  26: {
    label: "Zona soggiorno",
    icon: ""
  },
  27: {
    label: "Prodotti da bagno in omaggio",
    icon: ""
  },
  28: {
    label: "Lettore DVD",
    icon: ""
  },
  29: {
    label: "Lettore CD",
    icon: ""
  },
  30: {
    label: "Ventilatore",
    icon: ""
  },
  31: {
    label: "WC",
    icon: ""
  },
  32: {
    label: "Forno a microonde",
    icon: ""
  },
  33: {
    label: "Lavastoviglie",
    icon: ""
  },
  34: {
    label: "Lavatrice",
    icon: ""
  },
  35: {
    label: "Videoregistratore",
    icon: ""
  },
  36: {
    label: "Videogiochi",
    icon: ""
  },
  37: {
    label: "Patio",
    icon: ""
  },
  38: {
    label: "Bagno privato",
    icon: ""
  },
  39: {
    label: "Letti lunghi (oltre 2 metri)",
    icon: ""
  },
  40: {
    label: "Riscaldamento",
    icon: ""
  },
  41: {
    label: "Cabina armadio",
    icon: ""
  },
  42: {
    label: "Servizi igienici in comune",
    icon: ""
  },
  43: {
    label: "Pantofole",
    icon: ""
  },
  44: {
    label: "Canali satellitari",
    icon: ""
  },
  45: {
    label: "Cucina",
    icon: ""
  },
  46: {
    label: "Connessione WiFi",
    icon: ""
  },
  68: {
    label: "Canali via cavo",
    icon: ""
  },
  69: {
    label: "Vasca o doccia",
    icon: ""
  },
  70: {
    label: "Moquette",
    icon: ""
  },
  71: {
    label: "Camino",
    icon: ""
  },
  72: {
    label: "Servizi igienici aggiuntivi",
    icon: ""
  },
  73: {
    label: "Disponibilità di camere comunicanti",
    icon: ""
  },
  74: {
    label: "Cassaforte per computer portatile",
    icon: ""
  },
  75: {
    label: "TV a schermo piatto",
    icon: ""
  },
  76: {
    label: "Ingresso indipendente",
    icon: ""
  },
  77: {
    label: "Divano",
    icon: ""
  },
  79: {
    label: "Insonorizzazione",
    icon: ""
  },
  80: {
    label: "Pavimento in marmo o in piastrelle",
    icon: ""
  },
  81: {
    label: "Vista",
    icon: ""
  },
  82: {
    label: "Parquet o pavimento in legno",
    icon: ""
  },
  83: {
    label: "Sveglia telefonica",
    icon: ""
  },
  84: {
    label: "Sveglia",
    icon: ""
  },
  85: {
    label: "Zona pranzo",
    icon: ""
  },
  86: {
    label: "Bollitore elettrico",
    icon: ""
  },
  87: {
    label: "Accesso Executive Lounge",
    icon: ""
  },
  88: {
    label: "Docking station per iPod",
    icon: ""
  },
  89: {
    label: "Utensili da cucina",
    icon: ""
  },
  90: {
    label: "Zanzariera",
    icon: ""
  },
  91: {
    label: "Asciugamani lenzuola disponibili a pagamento",
    icon: ""
  },
  92: {
    label: "Sauna",
    icon: ""
  },
  93: {
    label: "Piscina privata a uso esclusivo",
    icon: ""
  },
  94: {
    label: "Asciugatrice",
    icon: ""
  },
  95: {
    label: "Armadio o guardaroba",
    icon: ""
  },
  96: {
    label: "Forno",
    icon: ""
  },
  97: {
    label: "Piano cottura",
    icon: ""
  },
  98: {
    label: "Tostapane",
    icon: ""
  },
  99: {
    label: "Barbecue",
    icon: ""
  },
  100: {
    label: "Bidet",
    icon: ""
  },
  101: {
    label: "Computer",
    icon: ""
  },
  102: {
    label: "iPad",
    icon: ""
  },
  103: {
    label: "Console per videogiochi",
    icon: ""
  },
  104: {
    label: "Xbox 360",
    icon: ""
  },
  105: {
    label: "PlayStation 2",
    icon: ""
  },
  106: {
    label: "PlayStation 3",
    icon: ""
  },
  107: {
    label: "Nintendo Wii",
    icon: ""
  },
  108: {
    label: "Vista mare",
    icon: ""
  },
  109: {
    label: "Vista lago",
    icon: ""
  },
  110: {
    label: "Vista giardino",
    icon: ""
  },
  111: {
    label: "Vista piscina",
    icon: ""
  },
  112: {
    label: "Vista montagna",
    icon: ""
  },
  113: {
    label: "Vista luogo di interesse",
    icon: ""
  },
  114: {
    label: "Computer portatile",
    icon: ""
  },
  115: {
    label: "Soluzioni anallergiche",
    icon: ""
  },
  116: {
    label: "Prodotti per le pulizie",
    icon: ""
  },
  117: {
    label: "Coperte elettriche",
    icon: ""
  },
  118: {
    label: "Bagno aggiuntivo",
    icon: ""
  },
  119: {
    label: "Lettore Blu-ray",
    icon: ""
  },
  120: {
    label: "Macchina da caffè",
    icon: ""
  },
  121: {
    label: "Vista città",
    icon: ""
  },
  122: {
    label: "Vista fiume",
    icon: ""
  },
  123: {
    label: "Terrazza",
    icon: ""
  },
  124: {
    label: "Asciugamani",
    icon: ""
  },
  125: {
    label: "Biancheria per la casa",
    icon: ""
  },
  126: {
    label: "Tavolo da pranzo",
    icon: ""
  },
  127: {
    label: "Seggiolone",
    icon: ""
  },
  129: {
    label: "Arredamento da esterno",
    icon: ""
  },
  130: {
    label: "Zona pranzo all'aperto",
    icon: ""
  },
  131: {
    label: "Intera unità situata al piano terra",
    icon: ""
  },
  132: {
    label: "Piani superiori accessibili tramite ascensore",
    icon: ""
  },
  133: {
    label: "Piani superiori accessibili solo tramite scale",
    icon: ""
  },
  134: {
    label: "Intera unità accessibile ai disabili",
    icon: ""
  },
  135: {
    label: "Indipendente",
    icon: ""
  },
  136: {
    label: "Semi-indipendente",
    icon: ""
  },
  137: {
    label: "Appartamento privato in edificio",
    icon: ""
  },
  138: {
    label: "Stand appendiabiti",
    icon: ""
  },
  139: {
    label: "Letto pieghevole",
    icon: ""
  },
  140: {
    label: "Stendibiancheria",
    icon: ""
  },
  141: {
    label: "Carta igienica",
    icon: ""
  },
  142: {
    label: "Copriprese di sicurezza per bambini",
    icon: ""
  },
  143: {
    label: "Giochi da tavolo puzzle",
    icon: ""
  },
  144: {
    label: "Libri, DVD o musica per bambini",
    icon: ""
  },
  145: {
    label: "Cancelletti di sicurezza per bambini",
    icon: ""
  },
  146: {
    label: "Divano letto",
    icon: ""
  },
  147: {
    label: "WC con maniglioni",
    icon: ""
  },
  148: {
    label: "Vasca da bagno per disabili",
    icon: ""
  },
  149: {
    label: "Doccia con accesso per sedie a rotelle",
    icon: ""
  },
  150: {
    label: "Doccia a filo pavimento",
    icon: ""
  },
  151: {
    label: "WC rialzato",
    icon: ""
  },
  152: {
    label: "Lavabo più basso",
    icon: ""
  },
  153: {
    label: "Campanello di emergenza nel bagno",
    icon: ""
  },
  154: {
    label: "Sedia per doccia",
    icon: ""
  },
  157: {
    label: "Piscina all'ultimo piano",
    icon: ""
  },
  158: {
    label: "Piscina a sfioro",
    icon: ""
  },
  159: {
    label: "Piscina con vista",
    icon: ""
  },
  160: {
    label: "Piscina riscaldata",
    icon: ""
  },
  161: {
    label: "Piscina di acqua salata",
    icon: ""
  },
  162: {
    label: "Vasca immersione ad acqua fredda",
    icon: ""
  },
  163: {
    label: "Teli",
    icon: ""
  },
  164: {
    label: "Zona acqua bassa",
    icon: ""
  },
  165: {
    label: "Copertura per piscina",
    icon: ""
  },
  166: {
    label: "Vino champagne",
    icon: ""
  },
  167: {
    label: "Bottiglia d'acqua",
    icon: ""
  },
  168: {
    label: "Frutta",
    icon: ""
  },
  169: {
    label: "Cioccolatini o biscotti",
    icon: ""
  },
  170: {
    label: "Pattumiere",
    icon: ""
  },
  171: {
    label: "Calici da vino",
    icon: ""
  },
  172: {
    label: "Console videogiochi: Xbox One",
    icon: ""
  },
  173: {
    label: "Console videogiochi: Wii U",
    icon: ""
  },
  174: {
    label: "Console videogiochi: PS4",
    icon: ""
  },
  175: {
    label: "Lettini e culle per bambini",
    icon: ""
  },
  176: {
    label: "Spazzolino da denti",
    icon: ""
  },
  177: {
    label: "Shampoo",
    icon: ""
  },
  178: {
    label: "Balsamo",
    icon: ""
  },
  179: {
    label: "Bagnoschiuma",
    icon: ""
  },
  180: {
    label: "Cuffia da doccia",
    icon: ""
  },
  181: {
    label: "Pigiama",
    icon: ""
  },
  182: {
    label: "Kimono",
    icon: ""
  },
  184: {
    label: "Presa elettrica vicino al letto",
    icon: ""
  },
  185: {
    label: "Adattatore",
    icon: ""
  },
  186: {
    label: "Cuscino di piume",
    icon: ""
  },
  187: {
    label: "Cuscino non di piume",
    icon: ""
  },
  188: {
    label: "Cuscino ipoallergenico",
    icon: ""
  },
  189: {
    label: "Alloggio accessibile tramite ascensore",
    icon: ""
  },
  190: {
    label: "Vista cortile interno",
    icon: ""
  },
  191: {
    label: "Vista su strada tranquilla",
    icon: ""
  },
  196: {
    label: "Hotspot portatile",
    icon: ""
  },
  198: {
    label: "Smartphone",
    icon: ""
  },
  199: {
    label: "Servizio streaming (per es. Netflix)",
    icon: ""
  },
  200: {
    label: "Armadietti",
    icon: ""
  },
  201: {
    label: "Allarme antifumo",
    icon: ""
  },
  202: {
    label: "Estintori",
    icon: ""
  },
  203: {
    label: "Accesso con chiavi",
    icon: ""
  },
  204: {
    label: "Accesso con chiavi magnetiche",
    icon: ""
  },
  205: {
    label: "Luci da lettura",
    icon: ""
  },
  206: {
    label: "Tappi per le orecchie",
    icon: ""
  },
  207: {
    label: "Tenda divisoria (per la privacy)",
    icon: ""
  },
  208: {
    label: "finestra",
    icon: ""
  },
  209: {
    label: "Vasca all'aperto",
    icon: ""
  },
  210: {
    label: "Tatami (pavimento tradizionale giapponese)",
    icon: ""
  },
  211: {
    label: "Rilevatore di monossido di carbonio",
    icon: ""
  },
  212: {
    label: "Fonti di monossido di carbonio",
    icon: ""
  },
  215: {
    label: "Purificatori d'aria",
    icon: ""
  },
  217: {
    label: "Colazione gratuita nell'executive lounge",
    icon: ""
  },
  218: {
    label: "Snack e drink gratuiti disponibili tutto il giorno nell'executive lounge",
    icon: ""
  },
  219: {
    label: "Snack e drink pomeridiani gratuiti nell'executive lounge",
    icon: ""
  },
  220: {
    label: "Snack e drink serali gratuiti nell'executive lounge",
    icon: ""
  },
  221: {
    label: "Accesso spa gratuito",
    icon: ""
  },
  222: {
    label: "Accesso palestra gratuito",
    icon: ""
  },
  223: {
    label: "Accesso gratuito alla sala conferenze al business center",
    icon: ""
  },
  224: {
    label: "Accesso alla piscina privata",
    icon: ""
  },
  225: {
    label: "Accesso a una spiaggia privata",
    icon: ""
  },
  226: {
    label: "Check-in e check-out privati nell'executive lounge",
    icon: ""
  },
  227: {
    label: "Servizio concierge",
    icon: ""
  },
  228: {
    label: "Riviste e giornali gratuiti nell'executive lounge",
    icon: ""
  },
  229: {
    label: "Servizi lavanderia gratuiti",
    icon: ""
  },
  230: {
    label: "Aria condizionata indipendente in ogni alloggio",
    icon: ""
  },
  231: {
    label: "Gel igienizzante per le mani",
    icon: ""
  },
  232: {
    label: "Alloggio accessibile a ospiti con disabilità uditiva",
    icon: ""
  },
  233: {
    label: "Camera accessibile",
    icon: ""
  },
  234: {
    label: "Doccia con seduta e maniglioni",
    icon: ""
  },
  235: {
    label: "missing_label",
    icon: ""
  }
}

export function get_room_facilities(key) {
  const facility = room_facilities[key]
  if (facility) {
   return {
     label: facility.label,
     icon: facility.icon || 'check_circle',
   }
  }
  return {
    name: key,
    icon: "check_circle",
  }
}